import { AnswerTypes } from '../enums/AnswerTypes';
import { Status } from '../enums/Status';
import { IQuestion } from '../interfaces/Question.interface';

// Initialize Question state
export const INITIAL_Question_STATE: IQuestion = {
  body: [],
  type: 'MULTIPLE_CHOICES',
  status: Status.ACTIVE,
  order: 1,
  answers: [
    {
      order: 1,
      type: AnswerTypes.TEXT,
      dataSources: [
        {
          options: [],
        },
      ],
    },
  ],
};
